<template>
  <div class="d-flex align-center ga-3">
    <template v-if="!authStore.isApplicant">
      <button
        type="button"
        class="the-header-user-section__notification position-relative d-inline-flex align-center justify-center border-0 bg-transparent cursor-pointer pa-0"
        @click="toggle"
        @pointerenter="ensureUnreadCountLoaded"
        @focus="ensureUnreadCountLoaded"
      >
        <VIcon icon="notification" size="24" color="gray-600" />
        <span
          v-if="unreadCount > 0"
          class="the-header-user-section__badge position-absolute d-inline-flex align-center justify-center rounded-circle bg-error text-white text-xs font-weight-bold"
        >
          {{ badgeLabel }}
        </span>
      </button>
      <VDivider vertical class="mx-1 my-2" style="height: 24px" />
    </template>

    <TheHeaderProfileMenu :compact="compact" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { VDivider, VIcon } from 'vuetify/components'
import TheHeaderProfileMenu from './TheHeaderProfileMenu/TheHeaderProfileMenu.vue'
import type { Props } from './TheHeaderUserSection.types'
import { useAuthStore } from '@/modules/Auth/store'
import { useNotificationPanel } from '@/modules/Notification/composables/useNotificationPanel'
import { toPersianDigits } from '@/modules/Reminder/utils/jalaliCalendar'

defineOptions({
  name: 'TheHeaderUserSection',
})

withDefaults(defineProps<Props>(), {
  compact: false,
})

const authStore = useAuthStore()
const { toggle, unreadCount, ensureUnreadCountLoaded } = useNotificationPanel()

const badgeLabel = computed(() => {
  const count = unreadCount.value
  if (count > 99) {
    return toPersianDigits('99+')
  }
  return toPersianDigits(String(count))
})
</script>

<style scoped>
.the-header-user-section__notification {
  width: 32px;
  height: 32px;
}

.the-header-user-section__badge {
  top: -2px;
  inset-inline-end: -4px;
  min-width: 18px;
  height: 18px;
  padding-inline: 4px;
  font-size: 10px;
  line-height: 1;
}
</style>
